module.exports = __webpack_public_path__ + "img/logo-no-bg.5ecc4418.svg";